/**
 *
 * */
class FocusOnCenter {
    /**
     * @property {Object} blocks
     * @property {Element} blocks.element
     * @property {Function} blocks.onFocusIn
     * @property {Function} blocks.onFocusOut
     * */
    static #blocks = []

    static run() {
        document.querySelectorAll(".js-focus-on-center")
            .forEach(element => this.push({ element }))

        document.addEventListener("scroll", () => this.#action(), { passive: true });
        this.#action()

        // не допустим повторного вызова
        delete this.run;
    }

    static #action() {
        const windowH = document.documentElement.clientHeight

        this.#blocks.forEach(block => {
            const element = block.element
                , onFocusIn = typeof block.onFocusIn === "function" ? block.onFocusIn : this.#defaultOnFocusIn
                , onFocusOut = typeof block.onFocusOut === "function" ? block.onFocusOut : this.#defaultOnFocusOut
                , elementRect = element.getBoundingClientRect()

            if (!(element instanceof Element)) return;

            if (windowH/2 > elementRect.top && windowH/2 < elementRect.bottom) onFocusIn(element)
            else onFocusOut(element)
        })
    }

    /**
     * @param {Object} block
     * @param {Element} block.element
     * @param {Function} block.onFocusIn
     * @param {Function} block.onFocusOut
     * */
    static push(block) {
        this.#blocks.push(block)
    }

    static #defaultOnFocusIn(element) {
        element.classList.add("focus")
    }

    static #defaultOnFocusOut(element) {
        element.classList.remove("focus")
    }
}

export default FocusOnCenter
